import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { dsf } from './game-board.helper';

export interface Cell {
  rowId: number;
  colId: number;
  visible: boolean;
  markedAsMine?: boolean;
  value: 'X' | '' | number;
}

export interface GameState {
  isDebug: boolean;
  isGameOver: boolean;
  win: boolean;
  grid?: Cell[][];
  minesMarked: number;
}

const initialState: GameState = {
  isDebug: false,
  minesMarked: 0,
  isGameOver: false,
  win: false,
};

export const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setGrid: (draftState, { payload: gridValues }: PayloadAction<Cell[][]>) => {
      draftState.grid = gridValues;
    },

    concealCell: (draftState, { payload: cell }: PayloadAction<Cell>) => {
      if (!draftState.grid) return;

      draftState.grid = dsf(draftState.grid, cell);
    },

    markMine: (draftState, { payload: cell }: PayloadAction<Cell>) => {
      if (!draftState.grid) return;

      const { colId, rowId } = cell;
      draftState.grid[rowId][colId].markedAsMine = true;
      draftState.minesMarked += 1;
    },

    unmarkMine: (draftState, { payload: cell }: PayloadAction<Cell>) => {
      if (!draftState.grid) return;

      const { colId, rowId } = cell;
      draftState.grid[rowId][colId].markedAsMine = false;
      draftState.minesMarked -= 1;
    },

    setDebug: (draftState, { payload: isDebug }: PayloadAction<boolean>) => {
      draftState.isDebug = isDebug;
    },

    setGameOver: draftState => {
      draftState.isGameOver = true;
    },

    setWin: draftState => {
      draftState.win = true;
    },
  },
});
